import AbsenceSupervisor from 'features/absenceSupervisor';
import { useTitle } from '../helpers';

/**
 * @page Absence page
 */
const AbsenceSupervisorPage = () => {
  useTitle('Неявки подчиненных');

  return (
    <div>
      <AbsenceSupervisor />
    </div>
  );
};

export default AbsenceSupervisorPage;
